import React from "react";
import styled from "styled-components";
import { useIntl, navigate } from "gatsby-plugin-intl";
import { useStaticQuery, graphql } from "gatsby";
import get from "lodash/get";

const StyledWrapper = styled.div`
  display: none;

  ${(props) => props.theme.responsive.desktop} {
    display: flex;
    height: 100%;
    flex: 1;
  }
`;
const StyledSubNavWrapper = styled.div`
  display: none;
  flex-direction: column;
  position: absolute;
  left: -1rem;
  top: 100%;
  background-color: white;
  padding: 0.2rem;
  width: 8rem;
`;

const StyledButtonUnderline = styled.div`
  position: absolute;
  left: -1rem;
  right: -1rem;
  bottom: -1px;
  height: 2px;
  background-color: ${(props) =>
    props.color === "black"
      ? props.theme.color.darkGrey
      : props.theme.color.smoke};
  z-index: 201;
  display: none;
`;

const StyledButton = styled.div`
  position: relative;
  font-size: 0.7rem;
  color: ${(props) =>
    props.color === "black"
      ? props.theme.color.darkGrey
      : props.theme.color.smoke};
  height: 100%;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  opacity: 0.7;
  &:hover {
    cursor: pointer;
    opacity: 1;
  }
`;

const StyledLink = styled.div`
  display: flex;
  align-items: center;
  padding: 0 1rem;
  height: 100%;
  &:hover {
    & ${StyledSubNavWrapper} {
      display: flex;
    }
    ${StyledButtonUnderline} {
      display: block;
    }
  }
  ${(props) => props.theme.responsive.mobile} {
    display: ${(props) => (props.isDesktop ? "block" : "none")};
  }
`;

const handleNavigateTo = (link) => {
  navigate(`${link}`);
  return true;
};

const Link = ({ title, color, link, isDesktop, children }) => {
  return (
    <StyledLink isDesktop={isDesktop}>
      <StyledButton color={color}>
        <div
          onClick={() => handleNavigateTo(link)}
          style={{ position: "absolute", top: 0, bottom: 0, left: 0, right: 0 }}
        ></div>
        <div>{title}</div>
        <StyledButtonUnderline color={color} />
        {children && <StyledSubNavWrapper>{children}</StyledSubNavWrapper>}
      </StyledButton>
    </StyledLink>
  );
};

const StyledSublink = styled.div`
  font-size: 0.6rem;
  padding: 0.4rem;
  border-radius: 4px;
  color: ${(props) => props.theme.color.darkGrey};
  &:hover {
    cursor: pointer;
    opacity: 0.6;
  }
  ${(props) => props.theme.responsive.mobile} {
    display: ${(props) => (props.isDesktop ? "block" : "none")};
  }
`;

const Sublink = ({ title, link, isDesktop }) => (
  <StyledSublink isDesktop={isDesktop} onClick={() => handleNavigateTo(link)}>
    {title}
  </StyledSublink>
);

const NavMenu = ({ color, ...props }) => {
  const intl = useIntl();
  const {
    strapi: {
      layout: { nav: nav },
    },
  } = useStaticQuery(graphql`
    {
      strapi {
        layout {
          nav {
            ... on STRAPI_ComponentBaseLink {
              __typename
              isDesktop
              link
              title {
                en
                es
                it
              }
            }
            ... on STRAPI_ComponentBaseDropdownLink {
              __typename
              isDesktop
              link
              sublinks {
                title {
                  en
                  es
                  it
                }
                link
                isDesktop
              }
              title {
                en
                es
                it
              }
            }
          }
        }
      }
    }
  `);
  return (
    <StyledWrapper>
      {nav.map((link) => {
        if (link.__typename === "STRAPI_ComponentBaseDropdownLink") {
          return (
            <Link
              key={link.link}
              color={color}
              title={get(link.title, `${intl.locale}`, "")}
              link={link.link}
              isDesktop={link.isDesktop}
            >
              {link.sublinks.map((sublink) => (
                <Sublink
                  key={sublink.link}
                  title={get(sublink.title, `${intl.locale}`, "")}
                  link={sublink.link}
                  isDesktop={sublink.isDesktop}
                />
              ))}
            </Link>
          );
        } else if (link.__typename === "STRAPI_ComponentBaseLink") {
          return (
            <Link
              key={link.link}
              color={color}
              title={get(link.title, `${intl.locale}`, "")}
              link={link.link}
              isDesktop={link.isDesktop}
            ></Link>
          );
        }
      })}
    </StyledWrapper>
  );
};

export { NavMenu, StyledLink };
